module.exports = __webpack_public_path__ + "common/icon-product-guide-1f36c4539800cf50edf87127cc032248.svg";